import { IApplicationState } from '../../types/redux';

export const isChatExistSelector = (state: IApplicationState): boolean => {
  return state.consultantCianChat.isChatExists;
};
